// extracted by mini-css-extract-plugin
module.exports = {"content":"purchaseControl_content__HcCA8","total":"purchaseControl_total__1BoQs"};